"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationVariants = exports.PaginationSizes = exports.PaginationElementTypes = void 0;
var PaginationVariants = {
  Primary: 'primary',
  Secondary: 'secondary',
  Outline: 'outline'
};
exports.PaginationVariants = PaginationVariants;
var PaginationSizes = {
  Tiny: 'tiny',
  Small: 'small',
  Normal: 'normal',
  Big: 'big',
  Huge: 'huge'
};
exports.PaginationSizes = PaginationSizes;
var PaginationElementTypes;
exports.PaginationElementTypes = PaginationElementTypes;
(function (PaginationElementTypes) {
  PaginationElementTypes["PreviousPageButton"] = "pagination:previous-page-button";
  PaginationElementTypes["SeparationIndicator"] = "pagination:pages-separation";
  PaginationElementTypes["PageButton"] = "pagination:page-button";
  PaginationElementTypes["NextPageButton"] = "pagination:next-page-button";
})(PaginationElementTypes || (exports.PaginationElementTypes = PaginationElementTypes = {}));